module.exports = __webpack_public_path__ + "img/icone-fungicide.fddf8546.svg";